<template>
  <div id="app">
    <div class="dashboard-wrapper">
      <div class="dashboard">
        <HeaderTitle />
        <KpiCards />
        <div class="main-content">
          <LeftPanel class="panel-left" />
          <CenterPanel class="panel-center" />
          <RightPanel class="panel-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from './components/HeaderTitle.vue'
import KpiCards from './components/KpiCards.vue'
import LeftPanel from './components/LeftPanel.vue'
import CenterPanel from './components/CenterPanel.vue'
import RightPanel from './components/RightPanel.vue'

export default {
  name: 'App',
  components: { HeaderTitle, KpiCards, LeftPanel, CenterPanel, RightPanel }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  background: #0A1628;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #FFFFFF;
}

.dashboard-wrapper {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.dashboard {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #0A1628 0%, #0F2440 50%, #0A1628 100%);
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px;
  position: relative;
}

.dashboard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(0, 212, 255, 0.03) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 50%, rgba(0, 255, 136, 0.02) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.dashboard::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(0, 212, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 212, 255, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
  z-index: 0;
}

.dashboard > * {
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  display: flex;
  gap: 12px;
  min-height: 700px;
}

.panel-left {
  width: 340px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.panel-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.panel-right {
  width: 380px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
